// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"884":"admin","966":"login"}[chunkId] + "." + {"884":"3d85ae2b","966":"6b46e14c"}[chunkId] + ".js";
};